"use client";

import { Provider } from "react-redux";
import { configureStore } from '@reduxjs/toolkit';
import sliceReducer from './store';

export const store = configureStore({
    reducer: {
        appState: sliceReducer
    }
})

export function Providers({ children }: { children: React.ReactNode }) {
  return <Provider store={store}>{children}</Provider>;
}